const CHANNEL_CODES = {
  WEB_AR: 'WEB_AR',
  WEB_CL: 'WEB_CL',
  WEB_BR: 'WEB_BR',
  WEB_US: 'WEB_US',
  WEB_MX: 'WEB_MX',
  WEB_AU: 'WEB_AU',
  WEB_BO: 'WEB_BO',
  WEB_CO: 'WEB_CO',
  WEB_ES: 'WEB_ES',
  WEB_FR: 'WEB_FR',
  WEB_IT: 'WEB_IT',
  WEB_NZ: 'WEB_NZ',
  WEB_PY: 'WEB_PY',
  WEB_PE: 'WEB_PE',
  WEB_GB: 'WEB_GB',
  WEB_UY: 'WEB_UY'
}

export default CHANNEL_CODES
